// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { get_viewportState } from "../../../init/init_viewportState";

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_nav() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const api = this.api;
  const fullpageMod = this.modules.fullpage;

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  console.log(`%cSectionScroller: init_nav()`, "color: #6682d6; font-weight: bold;");

  /////////////////////// Query nav ref. elements ////////////////////////
  ////////////////////////////////////////////////////////////////////////

  this.ref.nav = document.querySelector("[g-ref='SectionScroller:nav']");
  this.ref.wrpr_btnGroups = document.querySelector("[g-ref='SectionScroller:wrpr_btnGroups']");
  this.ref.nav_intro = document.querySelector("[g-ref='SectionScroller:nav_intro']");
  this.ref.nav_bewerben = document.querySelector("[g-ref='SectionScroller:nav_bewerben']");
  this.ref.nav_allgemein = document.querySelector("[g-ref='SectionScroller:nav_allgemein']");

  /////////////////////////// Link click init. ///////////////////////////
  ////////////////////////////////////////////////////////////////////////

  const navLinks = document.querySelectorAll("[g-ref^='SectionScroller:nav_'] a[data-target]");
  navLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const target = link.dataset.target;
      if (target) fullpageMod.scrollToElementInCurrentSection(`[data-id="${target}"]`, target, { offset: 100 });
    });
  });

  ////////////////////////////// Menu init. //////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  const btn_menu = document.querySelector("[g-ref='SectionScroller:btn_menu']");
  const menu = document.querySelector("[g-ref='SectionScroller:menu']");
  this.ref.menu = menu;
  this.ref.btn_menu = btn_menu;

  if (menu) {
    ///////// Menu btn. + close-btn. init. /////////
    ////////////////////////////////////////////////

    if (btn_menu) {
      // Menu btn. init.
      btn_menu.addEventListener("click", () => {
        const is_active = btn_menu.getAttribute("data-active") === "true";
        this.setState({ navState: { menuOpen: !is_active } });
      });

      // Close btn. init.
      const btn_menu_close = menu.querySelector("[data-ref='btn_close']");
      if (btn_menu_close) btn_menu_close.addEventListener("click", () => this.setState({ navState: { menuOpen: false } }));
    }

    // Close menu when clicking outside
    document.addEventListener("click", (e) => {
      const isMenuActive = menu.getAttribute("data-active") === "true";
      if (isMenuActive && !menu.contains(e.target) && !btn_menu.contains(e.target))
        this.setState({ navState: { menuOpen: false } });
    });

    //////////// Menu nav. links init. /////////////
    ////////////////////////////////////////////////

    const menuLinks = menu.querySelectorAll("[data-ref='link'][data-target]");
    this.ref.menuLinks = menuLinks;
    menuLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const target = link.dataset.target;
        if (!target) return;
        this.setState({ gatewayOpen: true }); // IMPROVE: only toggle, when click occurs in section before gateway
        fullpageMod.scrollToElement(`[data-id="${target}"]`, "bewerben", { offset: 100 });
        this.setState({ navState: { menuOpen: false }, gatewayOpen: false });
      });
    });
  }

  //////////////////// Active nav. & nav. link updt. /////////////////////
  ////////////////////////////////////////////////////////////////////////

  // - Nav. is toggled when corresp. content wrpr. comes into view
  // - Active-link bg. position/width updt. when corresp. wrpr. comes into view

  const { wrprs_content } = this.ref;
  wrprs_content.forEach((el_wrpr) => {
    // Find closest Fullpage section and overflow element
    const fpSection = el_wrpr.closest(".fp-section");
    const fpOverflow = fpSection ? fpSection.querySelector(".fp-overflow") : null;
    if (fpOverflow) {
      const id_wrpr = el_wrpr.dataset.id;
      const subch_wrpr = el_wrpr.dataset.subchapter;
      // const el_nav = document.querySelector(`[g-ref="SectionScroller:nav_${ch_wrpr}"]`);
      const el_nav = document.querySelector(`[g-ref="SectionScroller:nav_${subch_wrpr}"]`);
      const inst_scrollTrigger = ScrollTrigger.create({
        trigger: el_wrpr,
        scroller: fpOverflow,
        start: "top 90%",
        end: "bottom 90%",
        onEnter: () => {
          if (!this.state.navReady || this.state.onFullpageLeave) return;
          this.setState({ activeSection: id_wrpr });
          if (get_viewportState().is_mob) return; // No nav toggle on mobile
          api.toggle_nav(el_wrpr, { setFirstLinkActive: id_wrpr === "gateway" || id_wrpr === "ueber-den-fund" });
          if (id_wrpr != "gateway") api.toggle_activeNavLink(el_nav, id_wrpr);
        },
        onEnterBack: () => {
          if (!this.state.navReady || this.state.onFullpageLeave) return;
          this.setState({ activeSection: id_wrpr });
          if (get_viewportState().is_mob) return; // No nav toggle on mobile
          api.toggle_nav(el_wrpr);
          api.toggle_activeNavLink(el_nav, id_wrpr);
        },
      });
    } else {
      console.warn("No fp-overflow element found for:", el_wrpr);
    }
  });

  //////////////////////// Back-to-top btn. init. ////////////////////////
  ////////////////////////////////////////////////////////////////////////

  const btn_backToTop = document.querySelector("[g-ref='SectionScroller:btn_backToTop']");
  this.ref.btn_backToTop = btn_backToTop;

  if (btn_backToTop) {
    btn_backToTop.addEventListener("click", () => {
      const activeSection = this.state.activeSection;
      if (!activeSection) return;
      if (activeSection === "hero") fullpageMod.scrollToElement(`[data-id="gateway"]`, "intro", { offset: 0 });
      else fullpageMod.scrollToElement(`[data-id="hero"]`, "intro", { offset: 0 });
    });
  }

  /////////////////////////// Init. nav state ////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  this.setState({
    navState: {
      menuOpen: false,
      backToTopMuted: false,
    },
    activeSection: "hero",
    navReady: true,
  });

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // this.setState({ navReady: true });
  console.log("%cSectionScroller: init_nav() complete.", "color: #42b983; font-weight: bold;");
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
